import api from './api';

const paymentTermsMasterService = {
  getAllPaymentTerms: async (params = {}) => {
    try {
      const response = await api.get('/payment-terms-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching all payment terms master records:', error);
      throw error;
    }
  },

  getPaymentTermsById: async (id) => {
    try {
      const response = await api.get(`/payment-terms-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment terms master record with ID ${id}:`, error);
      throw error;
    }
  },

  createPaymentTerms: async (paymentTermsData) => {
    try {
      const response = await api.post('/payment-terms-master', paymentTermsData);
      return response.data;
    } catch (error) {
      console.error('Error creating payment terms master record:', error);
      throw error;
    }
  },

  updatePaymentTerms: async (id, paymentTermsData) => {
    try {
      const response = await api.put(`/payment-terms-master/${id}`, paymentTermsData);
      return response.data;
    } catch (error) {
      console.error(`Error updating payment terms master record with ID ${id}:`, error);
      throw error;
    }
  },

  deletePaymentTerms: async (id) => {
    try {
      const response = await api.delete(`/payment-terms-master/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting payment terms master record with ID ${id}:`, error);
      throw error;
    }
  },

  getPaymentTermsStats: async () => {
    try {
      const response = await api.get('/payment-terms-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching payment terms master stats:', error);
      throw error;
    }
  },

  getPaymentTermsByStatus: async (status) => {
    try {
      const response = await api.get(`/payment-terms-master/status/${status}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching payment terms by status ${status}:`, error);
      throw error;
    }
  },

  getActivePaymentTerms: async () => {
    try {
      const response = await api.get('/payment-terms-master/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active payment terms:', error);
      throw error;
    }
  },
};

export default paymentTermsMasterService;
